import React from 'react';

import { useApi } from 'hooks/ApiStoreContext';

import { CollapsableContainer } from '../CollapsableContainer';

import RecuperationActionsUtilisateurForm from './Form/RecuperationActionsUtilisateurForm';
import { useSubmitRecuperationActionsUtilisateurForm } from './hooks/useSubmitRecuperationActionsUtilisateurForm';
import { useValidateRecuperationActiviteUtilisateurForm } from './hooks/useValidateRecuperationActiviteUtilisateurForm';
import {
  HistoriqueAction,
  RecuperationActiviteUtilisateurFormValues,
} from './types';

import './RecuperationActionsUtilisateur.less';

const RecuperationActionsUtilisateur: React.FC = () => {
  const initialValues: RecuperationActiviteUtilisateurFormValues = {
    id: undefined,
    nom: undefined,
    prenom: undefined,
    dateDebut: undefined,
    dateFin: undefined,
  };

  const controller = useApi().AdminFonctionnelControllerApi;

  const validate = useValidateRecuperationActiviteUtilisateurForm(controller);

  const [selectedAction, setSelectedAction] = React.useState<
    HistoriqueAction | undefined
  >(undefined);

  const {
    submitForm,
    inProgressActionStatus,
    alertMessage,
    resetAlertMessage,
  } = useSubmitRecuperationActionsUtilisateurForm(selectedAction);

  const handleClickAction = (actionType: HistoriqueAction) => {
    resetAlertMessage();
    setSelectedAction(actionType);
  };

  const onCancel = () => {
    console.log('Cancel clicked');
    resetAlertMessage();
  };

  return (
    <CollapsableContainer
      title={'Récupération des actions utilisateur'}
      alertMessage={alertMessage}
    >
      <div className="recuperation-actions-utilisateur">
        <RecuperationActionsUtilisateurForm
          validate={validate}
          onCancel={onCancel}
          values={initialValues}
          submit={submitForm}
          handleClick={handleClickAction}
          inProgressActionStatus={inProgressActionStatus}
        />
      </div>
    </CollapsableContainer>
  );
};

export default RecuperationActionsUtilisateur;
